export default {
  header: 'Audit-Spezifikation',
  specificationName: 'Spezifikationsname',
};
